export default "__VITE_ASSET__CMxdK8rj__"